import React, {useEffect, useState} from "react";
import {displayLog} from "../common/common";
import {useDispatch} from "react-redux";
import {setLoading} from "../../../redux/actions/DRM_user.action";
import {Box, FormControl, TextField, Typography} from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Div from "@jumbo/shared/Div";
import {axios_tenant} from "../../../../axios";
import PropTypes from "prop-types";


const Editactivitycode = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    setId(props.id);
    setPairCode(props.pair_code);
    setActivityCode(props.activity_code);
    setActivityName(props.activity_name);
  }, [props.id, props.pair_code, props.activity_code, props.activity_name]);

  const [id, setId] = useState();
  const [pairCode, setPairCode] = useState();
  const [activityCode, setActivityCode] = useState();
  const [activityName, setActivityName] = useState();

  if (!props.show) {
    return null;
  }
// ,id,pairCode,activityName,activityCode
  // useEffect(()=>{
  // },[]);

  const register = async () => {
    dispatch(setLoading(true));
		let req = {
      id: id,
      pair_code: pairCode,
      activity_code: activityCode ?? null,
      activity_name: activityName,
    }
      let response = await axios_tenant.post("/drm/editActivityCode", req).then((res) => res.data);
		if (response?.success) {
      displayLog("Activity Code Updated","success");
		} else {
			displayLog(response.message, "error");
		}
    // 
		dispatch(setLoading(false));
    props.onCall();
    props.onClose();
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

  return (
    <Modal
          open={props.show}
            // onClose={()=> setOpenAdd(false)}
            onClose={props.onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
    >
          <Div sx={style}>
              <Typography id="modal-modal-title" variant="h4" component="h2">
                  Edit Activity Code
              </Typography>
              <br></br>
              <Typography id="modal-modal-title" variant="h6" component="h6">
                  <FormControl fullWidth>
                      
                      <TextField
                          sx={{mb:1}}
                          id="pair_code"
                          label="PAIR Code"
                          value={pairCode}
                          required
                          onChange={(e) => {
                            setPairCode(e.target.value);
                          }}
                          />
                      <br></br>
                      <TextField
                          sx={{mb:1}}
                          id="activity_code"
                          label="Activity Code"
                          value={activityCode}
                          onChange={(e) => {
                            setActivityCode(e.target.value);
                          }}
                          />
                      <br></br>
                      <TextField
                          sx={{mb:1}}
                          id="activity_name"
                          label="Activity Name"
                          value={activityName}
                          required
                          onChange={(e) => {
                            setActivityName(e.target.value);
                          }}
                          />
                      <br></br>
                  
                  </FormControl>
              
              </Typography>

              <Box textAlign="right" sx={{mt:2}}>
                      <Button type="submit" 
                              variant="contained" 
                              disabled={!pairCode || !activityName}
                              color="primary" 
                              onClick={(e) => {
                                  e.preventDefault();
                                  register();
                                }} >
                      Submit
                      </Button>{" "}
                      <Button type="submit" 
                              variant="contained" 
                              color="primary" 
                              onClick={props.onClose} >
                      Cancel
                      </Button>
              </Box>
          </Div>
    </Modal>
  );
}
Editactivitycode.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  pair_code: PropTypes.string,
  activity_code: PropTypes.string,
  activity_name: PropTypes.string,
  show: PropTypes.bool,
  onCall: PropTypes.func,
  onClose: PropTypes.func,
};

export default Editactivitycode;